import {
  Avatar,
  Box,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import useResponsive from '../../../../../Hooks/useResponsive';
import AddEvaluationManagerFormLanding from '../../../../appraisal/evaluation/addEvaluationSelf/AddEvaluationManagerFormLanding';

const ManageAppraisalCard = ({ open,cycleId,cycleName }) => {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  const [selected, setSelected] = useState(null);
  const { manageAppraisalData } = useSelector((state) => state.appraisal);

  useEffect(() => {
    if (!open) {
      setSelected(null);
    }
  }, [open]);

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Box sx={{ width: '30%', height: '85vh', overflow: 'scroll' }}>
        {manageAppraisalData?.map((item) => {
          return (
            <Paper
              key={item.userId}
              elevation={3}
              sx={{
                p: 1,
                mt: 2,
                border: selected?.userId === item?.userId ? 1 : '',
                borderColor: '#004a77',
                cursor: 'pointer',
              }}
              onClick={() => setSelected(item)}
            >
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Avatar
                  src={`https://workspace.teaminterval.net/assets/employee/photo/passport_size/${item.appraiserImage}.jpg`}
                />
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="subtitle1">{item.appraiserName}</Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Chip
                  icon={
                    item.completion == 0 ? (
                      <Icon icon="bitcoin-icons:cross-filled" width="18" height="18" />
                    ) : (
                      <Icon icon="mdi:tick-all" width="18" height="18" />
                    )
                  }
                  color={item.completion == 0 ? 'warning' : 'success'}
                  variant="outlined"
                  size="small"
                  label={item.completion == 0 ? 'Not completed' : 'Completed'}
                />
              </Box>
            </Paper>
          );
        })}
      </Box>

      <Box sx={{ width: '60%', mt: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button sx={{ mb: 1 }} size="small" variant="outlined" onClick={() => setSelected(null)}>
            Clear
          </Button>
        </Box>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#f0f0f0' }}>
              <TableRow>
                <TableCell>User ID</TableCell>
                <TableCell>Employee</TableCell>
                <TableCell>Rating</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Manager Review</TableCell>
                <TableCell>Published</TableCell>
                <TableCell>View Report</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selected?.appraisees?.length > 0 ? (
                selected.appraisees.map((row) => (
                  <TableRow key={row.userId}>
                    <TableCell>{row.userId}</TableCell>
                    {console.log(row)}
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar
                          src={`https://workspace.teaminterval.net/assets/employee/photo/passport_size/${row.employeeImage}.jpg`}
                          alt={row.employeeName}
                        />
                        <Typography>{row.employeeName}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{row.rating ?? '—'}</TableCell>
                    <TableCell>{row.status}</TableCell>
                    <TableCell>{row.managerReviewStatus ? 'Completed' : 'Pending'}</TableCell>
                    <TableCell>{row.publishedStatus ? 'Published' : 'Unpublished'}</TableCell>
                    <TableCell>
                      <AddEvaluationManagerFormLanding
                        userID={row?.userId}             
                        id={cycleId}                
                        title={cycleName}
                         viewOnly={true}
                         extraDisable={false}
                         isAdmin={true}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {selected ? 'No appraisees found.' : 'Select an appraiser to view details.'}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ManageAppraisalCard;

const appraisers = {
  tab: {},
  data: [
    {
      userId: 100,
      appraiserName: 'JASEEM P ',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'Sharika P Jayan',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 101,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 102,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 103,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 104,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 105,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 106,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 107,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 108,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 109,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
    {
      userId: 110,
      appraiserName: 'Tesdtttt',
      appraiserImage: 'https://example.com/images/jaseem.jpg',
      completion: 0,
      appraisees: [
        {
          userId: 10,
          employeeName: 'testttt123',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
        {
          userId: 11,
          employeeName: 'test1111111',
          employeeImage: 'https://example.com/images/sharika.jpg',
          rating: null,
          status: 'Pending',
          managerReviewStatus: false,
          publishedStatus: false,
        },
      ],
    },
  ],
};
